<template>
    <div>
        <!-- 搜索 -->
        <search   :search="true" :type="'AuthorityManagementRule'" @add-data="add_data" @search-data="search_data" @Export="Export" @Import="() => { this.ImportChild = true }"></search>
        <!-- 列表 -->
        <tables id="table-box"  :tableData="tableData"  :tableLabel="tableLabel" :ifheader="false" :Calculate="false" @event-button="event_button" ></tables>
        <!-- 新增接口 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_Authority" :title="title"  :width="'720px'" v-if="New_Authority">
            <NewAuthorityRule :visibles.sync="New_Authority" @Render="Render" :type="type" :row="row"></NewAuthorityRule>
        </el-dialog>
         <!-- 分页 -->
        <pagination
            v-show="(Number(total) > 0)"
            :total="Number(total)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            @pagination="Render"
        />
    </div>
</template>
<script>
import NewAuthorityRule from '../dialog/NewAuthorityRule'
export default {
  components: {
    NewAuthorityRule
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      New_Associated_User: false,
      SubsystemList: [],
      ImportChild: false,
      New_Authority: false,
      title: '',
      total: 0,
      type: '',
      row: {},
      uploadHeaders: {
        Authorization: ''
      },
      uploadData: {
        modelId: null
      },
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10
      },
      tableData: [],
      listData: [],
      tableLabel: [
        { label: '序号', width: '80', prop: 'index', align: 'center' },
        { label: '接口类型', width: '', prop: 'type', align: 'center' },
        { label: '子系统', width: '', prop: 'modelName', align: 'center' },
        { label: '约束类型', width: '80', prop: 'matchType', align: 'center' },
        { label: '路径规则', width: '', prop: 'urlPattern', align: 'center' },
        { label: '请求方式', width: '80', prop: 'reqMethod', align: 'center' },
        {
          label: '操作',
          width: '160',
          align: 'center',
          isOpera: true, // 判断是否生成按钮
          titleList: [
            // { title: '增加子级接口', status: 'primary' },
            { title: '修改', status: 'primary' },
            { title: '删除', status: 'primary' }
          ]
        }
      ]
    }
  },
  methods: {
    // 新增
    add_data (v) {
      this.title = '新增'
      this.New_Authority = true
      this.type = 'add'
      this.row = {}
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.loading = true
      setTimeout(() => {
        this.departmentList = this.$Layoutfun.ProcessingData(query, this.$department.list(), 'name')
        this.loading = false
      }, 300)
    },
    // 下拉框事件改变
    ChangeSelectFun (event) {
      if (!event) {
        this.departmentRemoteMethod(event)
      }
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 导出
    Export () {
      // this.tableLabel[8].ifshow = true
      setTimeout(() => {
        this.$tableToExcel('#table-box .el-table', '接口信息.xlsx')
        // this.tableLabel[8].ifshow = false
      })
      this.$message.success('导出成功')
    },
    // 导入
    Imports () {
      this.$refs.uploadfile.$refs['upload-inner'].handleClick()
    },
    // 列表按钮
    event_button (type, row) {
      if (type === '修改') {
        this.New_Authority = true
        this.title = '修改'
        this.type = 'edit'
        this.row = row
      } else if (type === '删除') {
        this.$confirm('此操作将永久删除该接口, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data
          if (typeof row.id !== 'string') {
            data = row.id.map(item => { return item.id })
          } else {
            data = row.id.split(',')
          }
          this.$http.Deletes('/path/api-rule/delete', data).then((res) => {
            this.$message.success('删除成功')
            this.Render()
          })
        }).catch(() => {})
      } else if (type === '增加子级权限') {
        this.New_Authority = true
        this.title = '增加子级权限'
        this.type = 'AddAuthority'
        this.row = row
      }
    },
    // 列表数据
    Render () {
      this.$http.get('/path/api-rule/page', this.matterParams).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    }
  },
  created () {
    this.SubsystemList = this.$Subsystem.list()
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
    // .main{
    //     display: flex;
    //     height: 800px;
    //     padding: 20px 0px 0 50px;
    //     .right{
    //        background: green;
    //        width: 100%;
    //        height: 100%;
    //     }
    // }
</style>
